import type { AxiosError, AxiosResponse } from 'axios'
import { call, takeLatest } from 'redux-saga/effects'

import type { CommonAxiosPayload } from '@services/types'

import { getErrorMessage, getFormErrors, getRFFFormErrors } from '@helpers'

import actions from './actions'
import * as api from './api'

function* callUrlSaga<Payload>({ payload, meta: { resolve, reject } }: AsyncSagaAction<CommonAxiosPayload<Payload>>) {
  try {
    const response: AxiosResponse<unknown> = yield call(api.callUrl, payload)
    yield call(resolve, response.data)
  } catch (error) {
    if (payload.isFormError || payload.isHookFormError) {
      const formErrors = payload.isHookFormError ? getFormErrors(error) : getRFFFormErrors(error)
      yield call(reject, formErrors)
    } else {
      const errorMsg = getErrorMessage(error as AxiosError)
      yield call(reject, errorMsg)
    }
  }
}

export function* fetchCitiesSaga({ payload, meta: { resolve, reject } }: AsyncSagaAction<number | string>) {
  try {
    const response: AxiosResponse<BackendCitiesResponse> = yield call(api.fetchCities, payload)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error as AxiosError)
    yield call(reject, errorMsg)
  }
}

export function* fetchExchangeRateSaga({
  payload,
  meta: { resolve, reject },
}: AsyncSagaAction<FetchExchangeRatePayload>) {
  try {
    const response: AxiosResponse<FetchExchangeRateResponse> = yield call(api.fetchExchangeRate, payload)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error as AxiosError)
    yield call(reject, errorMsg)
  }
}

// watcher Saga
export default function* commonSaga() {
  yield takeLatest(actions.callUrl.REQUEST, callUrlSaga)
  yield takeLatest(actions.fetchCities.REQUEST, fetchCitiesSaga)
  yield takeLatest(actions.fetchExchangeRate.REQUEST, fetchExchangeRateSaga)
}
